import router, { constantRoutes } from "@/router/index";
export default {
  namespaced: true,
  state: {},
  actions: {
    toFirstPage({ getters }) {
      return router.replace(getters.firstPage);
    }
  },
  mutations: {},
  getters: {
    visibleRoutes(state, getters, rootState, rootGetters) {
      const permissions = rootGetters["auth/permissions"] || [];
      const isTeacher = rootGetters["auth/isTeacher"];
      const isDistributor = rootGetters["auth/isDistributor"];
      const visibleRoutes = [];

      constantRoutes.forEach(oneModule => {
        let visibleModule = null;
        const haveModulePermission = !!permissions.find(
          el => el === oneModule.permission
        );
        if (haveModulePermission) {
          visibleModule = {
            ...oneModule
          };
          visibleModule.children = visibleModule.children.filter(el => {
            // 账号必须要有7的权限才能展示7 （7属于子菜单）// 特殊处理
            if (el.permission + "" === "7") {
              const haveModulePermission = !!permissions.find(el => {
                return el + "" === "7";
              });
              if (!haveModulePermission) {
                return false;
              }
            }
            if (el.rolePermission) {
              return el.rolePermission({ isTeacher, isDistributor });
            } else {
              return true;
            }
          });
        }
        if (visibleModule) {
          visibleRoutes.push(visibleModule);
        }
      });
      return visibleRoutes;
    },
    firstPage(state, getters) {
      const firstModule = getters.visibleRoutes[0];
      if (firstModule) {
        return `/${firstModule.path}/${firstModule.children[0].path}`;
      } else {
        return "/login";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/pages.js